/**
 * Gets all ancestor Account IDs for a given node
 */
export const getAncestors = (nodeId, hierarchyData) => {
	const ancestors = [];
	const node = hierarchyData[nodeId];

	if (!node || !node.data) return ancestors;

	let currentParentId = node.data.parentId;

	while (currentParentId && hierarchyData[currentParentId.toString()]) {
		const parentIdString = currentParentId.toString();
		ancestors.push(parentIdString);
		const parentNode = hierarchyData[parentIdString];
		currentParentId = parentNode?.data?.parentId;
	}

	return ancestors;
};
